import React from 'react'
import {connect} from "react-redux";
import {ReactComponent as ArrowRight} from "../../../../design-system/design_system/assets/icons/system/keyboard-arrow-right.svg";
import { bindActionCreators } from 'redux';
import {setMobileMenuState} from "../../../actions/HeaderActions";
const MobileMenuSlide = (props) => {

    const imagePath = window.weeksWebCloudConfig.REACT_APP_IMAGEURL;
    const {setMenuState,bookMenuArr, dreamMenuArr, secondaryNavArr} = props;
   
   const firstSlideFunc = (menuState) =>{
        setMenuState(menuState)
        //showMobileMenuFunc(menuState)
   }
  
    return (
        <>
        <div className="pt-3">
            
            <ul className="mobile-nav">
                <li className="py-2 px-4" data-testid="book-mobile-link" >
                    <a href="#" className="first-nav-set" onClick={()=>firstSlideFunc("BOOK")}>
                       <img src={imagePath+bookMenuArr.MobileLinkIcon} alt=""/> <span>{bookMenuArr.DisplayText}</span> 
                       <ArrowRight className="svg-fill-black float-right" width="32px" height="32px"/>
                    </a>
                </li>
                <li className="py-2 px-4" data-testid="dream-mobile-link">
                    <a href="#" className="first-nav-set" onClick={()=>firstSlideFunc("DREAM")}>
                       <img src={imagePath+dreamMenuArr.MobileLinkIcon}/> <span>{dreamMenuArr.DisplayText}</span> <ArrowRight className="svg-fill-black float-right" width="32px" height="32px"/>
                    </a>
                </li>
                {
                    secondaryNavArr.map((secondaryNavData, index)=>{
                        return(
                            <li className="py-2 px-4" key={index} data-testid={`seconday-mobile-link-${index}`}>
                            <a href={secondaryNavData.Links.URL} className="first-nav-set">
                               <img src={imagePath+secondaryNavData.Links.MobileLinkIcon}/> <span>{secondaryNavData.Links.DisplayText}</span>
                            </a>
                        </li>
                        )
                    })
                }
            </ul>
        </div>
        </>
    )
}
const mapStateToProps =(state) =>{
    return{
        headerNav:state.CommonReducer.headerNavigation
    }
    
}
const mapDispatchToProps = (dispatch) =>  bindActionCreators({
    setMenuState: setMobileMenuState
},dispatch)



export default connect(mapStateToProps, mapDispatchToProps)(MobileMenuSlide);
